import { bi } from '../../../services/loggers/bi';
import { useCallback } from 'react';
import { WixMediaRoot } from '../../../constants/WixMediaRoot';
import {
  homeDiscoverMediaClick,
  homeRecentFilesButtonClick,
  homeRecommendedButtonClick,
} from '@wix/bi-logger-media-data/v2';

export enum HomeButtonName {
  Apply = 'apply',
  NavLeft = 'nav_left',
  NavRight = 'nav_right',
  SeeAll = 'see_all',
  Settings = 'settings',
}

export const useTrackMediaHomeAnalytics = () => {
  const trackRecommendedButtonClick = useCallback((selection: string[], buttonName: HomeButtonName) => {
    bi.logger().report(
      homeRecommendedButtonClick({
        selection: selection.join(','),
        button_name: buttonName,
      }),
    );
  }, []);

  const trackRecentButtonClick = useCallback((buttonName: HomeButtonName) => {
    bi.logger().report(
      homeRecentFilesButtonClick({
        button_name: buttonName,
      }),
    );
  }, []);

  const discoverMediaButtonClick = useCallback((buttonName: HomeButtonName | WixMediaRoot) => {
    bi.logger().report(
      homeDiscoverMediaClick({
        button_name: buttonName,
      }),
    );
  }, []);

  return { trackRecommendedButtonClick, trackRecentButtonClick, discoverMediaButtonClick };
};
